// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/runs.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { WorkLogItem } from "./worklog";

export const protobufPackage = "api.devplan.types.runs";

export enum RunStatus {
  RUN_STATUS_UNSPECIFIED = 0,
  IN_PROGRESS = 1,
  AWAITING_ACTION = 2,
  READY_FOR_REVIEW = 3,
}

export function runStatusFromJSON(object: any): RunStatus {
  switch (object) {
    case 0:
    case "RUN_STATUS_UNSPECIFIED":
      return RunStatus.RUN_STATUS_UNSPECIFIED;
    case 1:
    case "IN_PROGRESS":
      return RunStatus.IN_PROGRESS;
    case 2:
    case "AWAITING_ACTION":
      return RunStatus.AWAITING_ACTION;
    case 3:
    case "READY_FOR_REVIEW":
      return RunStatus.READY_FOR_REVIEW;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum RunStatus");
  }
}

export function runStatusToJSON(object: RunStatus): string {
  switch (object) {
    case RunStatus.RUN_STATUS_UNSPECIFIED:
      return "RUN_STATUS_UNSPECIFIED";
    case RunStatus.IN_PROGRESS:
      return "IN_PROGRESS";
    case RunStatus.AWAITING_ACTION:
      return "AWAITING_ACTION";
    case RunStatus.READY_FOR_REVIEW:
      return "READY_FOR_REVIEW";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum RunStatus");
  }
}

export enum RunItemType {
  RUN_ITEM_TYPE_UNSPECIFIED = 0,
  TASK = 1,
  USER_STORY = 2,
}

export function runItemTypeFromJSON(object: any): RunItemType {
  switch (object) {
    case 0:
    case "RUN_ITEM_TYPE_UNSPECIFIED":
      return RunItemType.RUN_ITEM_TYPE_UNSPECIFIED;
    case 1:
    case "TASK":
      return RunItemType.TASK;
    case 2:
    case "USER_STORY":
      return RunItemType.USER_STORY;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum RunItemType");
  }
}

export function runItemTypeToJSON(object: RunItemType): string {
  switch (object) {
    case RunItemType.RUN_ITEM_TYPE_UNSPECIFIED:
      return "RUN_ITEM_TYPE_UNSPECIFIED";
    case RunItemType.TASK:
      return "TASK";
    case RunItemType.USER_STORY:
      return "USER_STORY";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum RunItemType");
  }
}

/** Run-specific data for a task or user story. Entity details should be looked up from DocumentEntity. */
export interface RunItem {
  entityId: string;
  latestWorklog?:
    | WorkLogItem
    | undefined;
  /** JSON-serialized JobRun from codeup */
  latestJobRunJson?: string | undefined;
  computedStatus: RunStatus;
  lastActivity: Date | undefined;
  type: RunItemType;
}

function createBaseRunItem(): RunItem {
  return {
    entityId: "",
    latestWorklog: undefined,
    latestJobRunJson: undefined,
    computedStatus: 0,
    lastActivity: undefined,
    type: 0,
  };
}

export const RunItem: MessageFns<RunItem> = {
  encode(message: RunItem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.entityId !== "") {
      writer.uint32(10).string(message.entityId);
    }
    if (message.latestWorklog !== undefined) {
      WorkLogItem.encode(message.latestWorklog, writer.uint32(18).fork()).join();
    }
    if (message.latestJobRunJson !== undefined) {
      writer.uint32(26).string(message.latestJobRunJson);
    }
    if (message.computedStatus !== 0) {
      writer.uint32(32).int32(message.computedStatus);
    }
    if (message.lastActivity !== undefined) {
      Timestamp.encode(toTimestamp(message.lastActivity), writer.uint32(42).fork()).join();
    }
    if (message.type !== 0) {
      writer.uint32(48).int32(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunItem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entityId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latestWorklog = WorkLogItem.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.latestJobRunJson = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.computedStatus = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.lastActivity = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunItem {
    return {
      entityId: isSet(object.entityId)
        ? globalThis.String(object.entityId)
        : isSet(object.entity_id)
        ? globalThis.String(object.entity_id)
        : "",
      latestWorklog: isSet(object.latestWorklog)
        ? WorkLogItem.fromJSON(object.latestWorklog)
        : isSet(object.latest_worklog)
        ? WorkLogItem.fromJSON(object.latest_worklog)
        : undefined,
      latestJobRunJson: isSet(object.latestJobRunJson)
        ? globalThis.String(object.latestJobRunJson)
        : isSet(object.latest_job_run_json)
        ? globalThis.String(object.latest_job_run_json)
        : undefined,
      computedStatus: isSet(object.computedStatus)
        ? runStatusFromJSON(object.computedStatus)
        : isSet(object.computed_status)
        ? runStatusFromJSON(object.computed_status)
        : 0,
      lastActivity: isSet(object.lastActivity)
        ? fromJsonTimestamp(object.lastActivity)
        : isSet(object.last_activity)
        ? fromJsonTimestamp(object.last_activity)
        : undefined,
      type: isSet(object.type) ? runItemTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: RunItem): unknown {
    const obj: any = {};
    if (message.entityId !== "") {
      obj.entityId = message.entityId;
    }
    if (message.latestWorklog !== undefined) {
      obj.latestWorklog = WorkLogItem.toJSON(message.latestWorklog);
    }
    if (message.latestJobRunJson !== undefined) {
      obj.latestJobRunJson = message.latestJobRunJson;
    }
    if (message.computedStatus !== 0) {
      obj.computedStatus = runStatusToJSON(message.computedStatus);
    }
    if (message.lastActivity !== undefined) {
      obj.lastActivity = message.lastActivity.toISOString();
    }
    if (message.type !== 0) {
      obj.type = runItemTypeToJSON(message.type);
    }
    return obj;
  },

  create(base?: DeepPartial<RunItem>): RunItem {
    return RunItem.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RunItem>): RunItem {
    const message = createBaseRunItem();
    message.entityId = object.entityId ?? "";
    message.latestWorklog = (object.latestWorklog !== undefined && object.latestWorklog !== null)
      ? WorkLogItem.fromPartial(object.latestWorklog)
      : undefined;
    message.latestJobRunJson = object.latestJobRunJson ?? undefined;
    message.computedStatus = object.computedStatus ?? 0;
    message.lastActivity = object.lastActivity ?? undefined;
    message.type = object.type ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
